var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"page-title text-center"},[_vm._v("模板库")]),_c('p',{staticClass:"gray text-center paddingT20"},[_vm._v("待完善...")])])}]

export { render, staticRenderFns }